/*
 * Autorski upsell koszyka — interakcje:
 *  - klik karty rozwija/zwija detal (akordeon),
 *  - wybór wariantu (swatch/dropdown) aktualizuje cenę + cel przycisku,
 *  - "Dodaj" dodaje wariant przez AJAX i odświeża <cart-drawer> (Section Rendering).
 */
(function () {
  if (window.__osUpsellInit) return;
  window.__osUpsellInit = true;

  function sectionIdOf(el) {
    var s = el.closest('.shopify-section');
    return (s && s.id) ? s.id.replace('shopify-section-', '') : 'cart-drawer';
  }

  function refreshDrawer(html) {
    if (!html) return;
    var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('cart-drawer');
    var cur = document.querySelector('cart-drawer');
    if (fresh && cur) {
      cur.classList.toggle('is-empty', fresh.classList.contains('is-empty'));
      cur.innerHTML = fresh.innerHTML;
    }
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  }

  function swapImg(img, next) {
    if (!img || !next || img.getAttribute('src') === next) return;
    // Preload: stare zdjęcie zostaje widoczne aż nowe się pobierze → brak białego błysku
    var pre = new Image();
    pre.onload = pre.onerror = function () { img.src = next; };
    pre.src = next;
  }

  function updateVariant(detail, vid, price, cprice, vimg) {
    if (!detail) return;
    var add = detail.querySelector('.os-up-add');
    if (add && vid) add.setAttribute('data-variant-id', vid);
    var pb = detail.querySelector('[data-price]');
    if (pb && price) pb.textContent = price;
    var ps = detail.querySelector('[data-cprice]');
    if (ps) { if (cprice) { ps.textContent = cprice; ps.style.display = ''; } else { ps.style.display = 'none'; } }
    // podmiana zdjęcia na zdjęcie wariantu (fallback: zdjęcie główne) — OBA: mały podgląd w detalu I duża karta u góry
    var fallbackMedia = detail.querySelector('[data-os-up-media]');
    swapImg(fallbackMedia, (vimg && vimg.length) ? vimg : (fallbackMedia && fallbackMedia.getAttribute('data-default-src')));
    var up = detail.closest('.os-up');
    var idx = detail.getAttribute('data-os-up-detail');
    var cardImg = up && up.querySelector('.os-up-card[data-os-up-card="' + idx + '"] .os-up-card__img');
    swapImg(cardImg, (vimg && vimg.length) ? vimg : (cardImg && cardImg.getAttribute('data-default-src')));
  }

  function addToCart(btn) {
    var vid = btn.getAttribute('data-variant-id');
    // guard: brak wariantu, przycisk disabled, albo dodawanie już trwa (blok podwójnego kliknięcia)
    if (!vid || btn.disabled || btn.classList.contains('is-busy')) return;
    var sid = sectionIdOf(btn);
    btn.classList.add('is-busy');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: vid, quantity: 1 }], sections: sid, sections_url: window.location.pathname })
    })
      .then(function (r) {
        // 422 (wyprzedany / limit zapasu / błąd koszyka): NIE udawaj sukcesu, przejdź do .catch (odblokuj przycisk)
        if (!r.ok) { throw new Error('add-failed-' + r.status); }
        return r.json();
      })
      .then(function (d) {
        var html = d && d.sections && d.sections[sid];
        if (html) { refreshDrawer(html); return; }
        return fetch(window.location.pathname + '?sections=' + encodeURIComponent(sid))
          .then(function (r) { return r.json(); })
          .then(function (j) { refreshDrawer(j && j[sid]); });
      })
      .catch(function () { btn.classList.remove('is-busy'); });
  }

  document.addEventListener('click', function (e) {
    var arrow = e.target.closest('[data-os-up-prev], [data-os-up-next]');
    if (arrow) {
      var upA = arrow.closest('.os-up');
      var row = upA && upA.querySelector('[data-os-up-row]');
      if (row) {
        var dir = arrow.hasAttribute('data-os-up-next') ? 1 : -1;
        row.scrollBy({ left: dir * row.clientWidth, behavior: 'smooth' });
      }
      return;
    }
    var card = e.target.closest('.os-up-card');
    if (card) {
      var up = card.closest('.os-up');
      var idx = card.getAttribute('data-os-up-card');
      var detail = up.querySelector('.os-up-detail[data-os-up-detail="' + idx + '"]');
      var wasOpen = card.classList.contains('is-active');
      up.querySelectorAll('.os-up-card').forEach(function (c) { c.classList.remove('is-active'); c.setAttribute('aria-expanded', 'false'); });
      up.querySelectorAll('.os-up-detail').forEach(function (d) { d.hidden = true; d.classList.remove('is-active'); });
      if (!wasOpen && detail) {
        card.classList.add('is-active');
        card.setAttribute('aria-expanded', 'true');
        detail.hidden = false;
        detail.classList.add('is-active');
        // przewiń BODY koszyka tak, żeby rozwinięta karta + 2 guziki były w pełni widoczne (nie chowały się za stopką)
        setTimeout(function () {
          var scroller = detail.closest('.cart-drawer__body');
          if (!scroller) {
            var el = detail.parentElement;
            while (el && el !== document.body) {
              var oy = getComputedStyle(el).overflowY;
              if ((oy === 'auto' || oy === 'scroll') && el.scrollHeight > el.clientHeight) { scroller = el; break; }
              el = el.parentElement;
            }
          }
          if (scroller) {
            var sRect = scroller.getBoundingClientRect();
            var dRect = detail.getBoundingClientRect();
            var delta = (dRect.bottom - sRect.bottom) + 16;
            if (delta > 0) scroller.scrollTo({ top: scroller.scrollTop + delta, behavior: 'smooth' });
          }
        }, 70);
      }
      return;
    }
    var sw = e.target.closest('.os-up-swatch');
    if (sw && !sw.disabled) {
      var grp = sw.closest('[data-os-up-variant]');
      grp.querySelectorAll('.os-up-swatch').forEach(function (s) { s.classList.remove('is-sel'); });
      sw.classList.add('is-sel');
      updateVariant(sw.closest('.os-up-detail'), sw.getAttribute('data-variant-id'), sw.getAttribute('data-vprice'), sw.getAttribute('data-vcprice'), sw.getAttribute('data-vimg'));
      return;
    }
    var decline = e.target.closest('.os-up-decline');
    if (decline) {
      var up2 = decline.closest('.os-up');
      up2.querySelectorAll('.os-up-card').forEach(function (c) { c.classList.remove('is-active'); c.setAttribute('aria-expanded', 'false'); });
      up2.querySelectorAll('.os-up-detail').forEach(function (d) { d.hidden = true; d.classList.remove('is-active'); });
      return;
    }
    // Przycisk „Dodaj": zarówno w detalu (.os-up-add), jak i szybki pod ceną (.os-up-cell__add)
    var add = e.target.closest('.os-up-add, .os-up-cell__add');
    if (add) { addToCart(add); }
  });

  document.addEventListener('change', function (e) {
    var sel = e.target.closest('select[data-os-up-variant]');
    if (sel) {
      var opt = sel.options[sel.selectedIndex];
      updateVariant(sel.closest('.os-up-detail'), opt.value, opt.getAttribute('data-vprice'), opt.getAttribute('data-vcprice'), opt.getAttribute('data-vimg'));
    }
  });
})();
